import { Notifier } from "@opendaw/lib-std";
export class AssetSignaling {
    #socket;
    #topic;
    #notifier = new Notifier();
    #pending = [];
    #connected = false;
    #terminated = false;
    constructor(socket, topic) {
        this.#socket = socket;
        this.#topic = topic;
        this.#socket.onopen = () => {
            console.debug("[P2P:Signaling] connected to", topic);
            this.#connected = true;
            this.#flush();
        };
        this.#socket.onmessage = (event) => this.#onMessage(event.data);
        this.#socket.onclose = () => {
            console.debug("[P2P:Signaling] socket closed");
            this.terminate();
        };
        this.#socket.onerror = () => {
            console.debug("[P2P:Signaling] socket error");
            this.terminate();
        };
        if (socket.readyState === 1) {
            this.#connected = true;
        }
        this.#subscribe();
    }
    get topic() { return this.#topic; }
    subscribe(observer) {
        return this.#notifier.subscribe(observer);
    }
    publish(message) {
        if (this.#terminated) {
            return;
        }
        this.#send({ type: "publish", topic: this.#topic, data: message });
    }
    terminate() {
        if (this.#terminated) {
            return;
        }
        this.#terminated = true;
        this.#unsubscribe();
        this.#socket.onopen = null;
        this.#socket.onmessage = null;
        this.#socket.onclose = null;
        this.#socket.onerror = null;
        this.#socket.close();
    }
    #subscribe() {
        this.#send({ type: "subscribe", topics: [this.#topic] });
    }
    #unsubscribe() {
        if (this.#connected) {
            this.#socket.send(JSON.stringify({ type: "unsubscribe", topics: [this.#topic] }));
        }
    }
    #send(message) {
        if (this.#connected) {
            console.debug("[P2P:Signaling] sending:", message.type ?? message.topics);
            this.#socket.send(JSON.stringify(message));
        }
        else {
            console.debug("[P2P:Signaling] queuing (not connected):", message.type ?? message.topics);
            this.#pending.push(message);
        }
    }
    #flush() {
        console.debug("[P2P:Signaling] flushing", this.#pending.length, "queued messages");
        for (const message of this.#pending) {
            this.#socket.send(JSON.stringify(message));
        }
        this.#pending.length = 0;
    }
    #onMessage(raw) {
        try {
            const envelope = JSON.parse(raw);
            if (envelope.topic !== this.#topic) {
                return;
            }
            const message = envelope.data;
            console.debug("[P2P:Signaling] received:", message.type, "from", message.peerId);
            this.#notifier.notify(message);
        }
        catch (_error) {
            console.debug("[P2P:Signaling] malformed message:", raw);
        }
    }
}
